import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ModalContainer } from '../common';
import { ActionButton } from '../common/petCloud/ActionButton';

import styles from './PetReplaceModal.module.css';

const PetReplaceModal = ({
  endDate = '',
  isOpen = false,
  onClose = () => { },
  onUndoReplacement = () => { },
  onConfirmReplacement = () => { },
  originalPet = '',
  petReplace = '',
  undoReplace = false,
}) => {
  const { t } = useTranslation('petDemos');

  const modalContent = () => {
    if (undoReplace) {
      return (
        <>
          <h3 className={styles.headerTitle}>
            {t('petReplaceModal.undoTitle')}
          </h3>

          <p className={styles.description}>
            <Trans
              components={{
                bold: <span className={styles.boldDescription} />,
                warning: <span className={styles.warningText} />,
              }}
              i18nKey="petReplaceModal.undoDescription"
              ns="petDemos"
              values={{
                originalPet,
                petReplace,
              }}
            />
          </p>
        </>
      );
    }

    return (
      <div>
        <h3 className={styles.headerTitle}>
          {t('petReplaceModal.title')}
        </h3>

        <p className={styles.description}>
          <Trans
            components={{ bold: <span className={styles.boldDescription} /> }}
            i18nKey="petReplaceModal.description"
            ns="petDemos"
            values={{
              endDate,
              petName: originalPet,
            }}
          />
        </p>
      </div>
    );
  };

  const primaryButtonTitle = undoReplace
    ? t('petReplaceModal.undoReplacement')
    : t('petReplaceModal.confirmReplacement');

  const secondaryButtonTitle = undoReplace
    ? t('petReplaceModal.keepReplacement')
    : t('petReplaceModal.cancel');

  const handlePrimaryClick = () => {
    if (undoReplace) {
      onUndoReplacement();
    } else {
      onConfirmReplacement();
    }
  };

  const handleSecondaryClick = () => {
    onClose();
  };

  return (
    <ModalContainer
      cancelable
      contentStyle={styles.modal}
      handleOutClick={onClose}
      id="petReplacement"
      show={isOpen}
    >
      <div className={styles.container}>
        {modalContent()}

        <div className={styles.buttonsContainer}>
          <ActionButton
            className={styles.actionButton}
            noMargin
            onClick={handlePrimaryClick}
            title={primaryButtonTitle}
          />

          <ActionButton
            className={styles.cancelButton}
            isSecondaryButton
            noMargin
            onClick={handleSecondaryClick}
            title={secondaryButtonTitle}
          />
        </div>
      </div>
    </ModalContainer>
  );
};

export { PetReplaceModal };
